import type { ComponentProps } from 'react';
import { ToggleGroup } from 'components/ui/toggle-group';

type Props<Value extends string> = Omit<ComponentProps<typeof ToggleGroup>, 'value' | 'onValueChange' | 'onChange'> & {
    value: Value;
    onChange: (value: Value) => void;
};

/** A toggle group that always holds one choice: pressing the chosen item would empty it, so that changes nothing. */
export function SingleChoiceGroup<Value extends string>({ value, onChange, ...props }: Props<Value>) {
    return (
        <ToggleGroup
            {...props}
            value={[value]}
            onValueChange={(next: string[]) => {
                if (next[0]) onChange(next[0] as Value);
            }}
        />
    );
}
